import { useContext } from 'react'
import { UserDataContext } from './UserDataContext'

export function useUserData() {
  const context = useContext(UserDataContext)

  if (!context) {
    throw new Error('useUserData must be used within UserDataProvider')
  }

  const { state } = context

  return {
    uid: state.uid,
    loading: state.loading,
    initialized: state.initialized,
    error: state.error
  }
}
